import React from 'react';

export default function LibrarianHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,32.74 10.31,32.74 10.31,8.42 38.0,8.42" fill="#B7B7AF" />
      <polygon points="10.31,32.74 38.0,32.74 29.69,28.59 2.0,28.59" fill="#868679" opacity="0.95" />
      <polygon points="10.31,32.74 2.0,28.59 2.0,4.27 10.31,8.42" fill="#868679" opacity="0.95" />
      <polygon points="37.56,35.73 10.54,35.73 10.54,8.71 37.56,8.71" fill="#B7B7AF" />
      <polygon points="10.54,35.73 37.56,35.73 29.46,31.68 2.44,31.68" fill="#868679" opacity="0.95" />
      <polygon points="10.54,35.73 2.44,31.68 2.44,4.66 10.54,8.71" fill="#868679" opacity="0.95" />
    </svg>
  );
}
